/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/presentationList.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { GET_ATTRIBUTES } from "../graphql/getAttributes.query";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAttributesMethods extends IPluginMethodMap {
    getAttributes(args: any): Promise<any>;
}

export class AttributesService implements IAgentPlugin {
    readonly methods: IAttributesMethods;

    constructor() {
        this.methods = {
            getAttributes: this.getAttributesProps.bind(this),
        };
    }

    async getAttributesProps(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log("hifiAtt->", args);
        const filter = args?.id ? {
            costumeType: {
                eq: args?.id,
            },
        } : {};
        let addOnFilter = {};
        if (args?.id) {
            addOnFilter = {
                costumeType: {
                    eq: args?.id,
                },
            };
        }
        if (args?.fid) {
            addOnFilter = {
                ...addOnFilter, _id: { eq: args?.fid },
            };
        }
        console.log("hifiAttadd->", addOnFilter);

        try {
            if (client) {
                if(args?.fid && args?.id){
                    const res = await client.query({
                        query: GET_ATTRIBUTES,
                        variables:{
                            filters:addOnFilter
                        } ,
                        fetchPolicy: "network-only",
                    });
    
                    if (res?.data) {
                        console.log("hifiAttres=>", res?.data?.getFullCostumeFeatureInventories?.content)
                        return {
                            searchAttributeFilter: this.format(res?.data?.getFullCostumeFeatureInventories?.content) ?? []
                        };
                    }
                }
                else{
                    return {
                        searchAttributeFilter:[]
                    }
                }
            }
        } catch (err: any) {
            console.log(`error in table data`, err);
            return {
                isEmpty: true,
            };
        }
    }
    private format(data: any) {
        const uniqueCANames = new Set();
        data.forEach(item => {
            uniqueCANames.add(item.CA.name);
        });

        const uniqueCANamesArray = Array.from(uniqueCANames);
        return uniqueCANamesArray.map((_item) => {
            return {
                label: _item,
                value: _item,
            };
        });
    }
}
